module.exports = __webpack_public_path__ + "media/plastic_4.94529351.webm";